import React, { useMemo } from 'react';
import ChoiceWrap from '../ui/forms/ChoiceWrap';
import MyInfoListWrap from '../ui/forms/MyInfoListWrap';
import MyInfoBoxWrap from '../ui/forms/MyInfoBoxWrap';
import MyInfoImg from '../ui/forms/MyInfoImg';
import MyInfoLink from '../ui/forms/MyInfoLink';
import MyInfoText from '../ui/forms/MyInfoText';
import OutlineButton from '../ui/OutlineButton';
import OnlineListWrap from '../ui/forms/OnlineListWrap';
import List from '../ui/forms/List';
import primarySingpassButton from '../../assets/images/primary-singpass-button.png';
import neutralSingpassButton from '../../assets/images/neutral-singpass-button.png';
import singpassLogo from '../../assets/images/singpass-logo.png';
import SingpassButtonImage from '../ui/forms/SingpassButtonImage';
import * as sharedComps from '../../templates/consents/shared/sharedComponents';

const ApplicationChoice = props => {
    const { myInfoSettings } = props;

    const includeCpfAgree = useMemo(
        () => myInfoSettings?.filter(item => item.key === 'AGREE_INCLUDECPF_TEXT')[0],
        [myInfoSettings]
    );

    const singpassButton = props.brand === 'lexus' ? neutralSingpassButton : primarySingpassButton;
    return (
        <>
            <div data-test-id="applicationChoice">
                <ChoiceWrap>
                    You can complete your application by retrieving Myinfo with Singpass or fill up our online
                    application form. Myinfo is applicable for Singapore Citizens, Singapore Permanent Resident and FIN
                    Holders.
                </ChoiceWrap>
                {props.corpCustomer === true && (
                    <sharedComps.Checkbox>
                        <input
                            type="checkbox"
                            onChange={props.handleCheckbox}
                            name="stage3_consent"
                            value={props.stage3_consent}
                            checked={props.stage3_consent}
                        />
                        <span />
                        <sharedComps.CheckboxText>
                            <div dangerouslySetInnerHTML={{ __html: includeCpfAgree?.value }} />
                        </sharedComps.CheckboxText>
                    </sharedComps.Checkbox>
                )}
                <SingpassButtonImage src={singpassButton} onClick={() => props.onApply(true)} />
                <MyInfoListWrap>
                    <List>
                        <li>No supporting documents required</li>
                        <li>Estimated time of 5min</li>
                    </List>
                </MyInfoListWrap>
                <MyInfoBoxWrap>
                    <MyInfoImg alt="MyInfo Logo" src={singpassLogo} />
                    <MyInfoText>
                        Singpass enables you to retrieve your personal data from participating Government agencies.
                    </MyInfoText>
                    <MyInfoLink href="https://www.singpass.gov.sg/myinfo/intro" target="_blank">
                        Find out more
                    </MyInfoLink>
                </MyInfoBoxWrap>
                <OutlineButton onClick={() => props.onApply(false)}>Apply with Online Application Form</OutlineButton>
                <OnlineListWrap>
                    Please prepare the following documents: <br />
                    <List>
                        <li>Scanned Copy of NRIC/Passport/ Employment Pass</li>
                        <li>
                            Income Proof (Latest 6 Months CPF / 2 Years Notice Of Assessment / Latest 3 Months
                            Computerized Payslip )
                        </li>
                    </List>
                </OnlineListWrap>
            </div>
        </>
    );
};

export default ApplicationChoice;
